import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table } from 'react-bootstrap';

import PropTypes from 'prop-types';

import { faMobileAlt, faGlobe } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";




class PaymentNoticeScanView extends React.Component {
	
	constructor(props) {
		super(props);
		
		this.app = this.props.app;
		this.getMvcModuleObject = this.app.getMvcModuleObject;
		this.getMvcMyQuoteObject = this.app.getMvcMyQuoteObject;

		this.uuid = this.app.guid();

		this.invoice = this.props.invoice;
		
		this.closing = false;

		this.state = {
			message_text: 'scanning...',
			paymentnotices: []
		};
	}

	_setState(state) {
		if (this.closing !== true)
		this.setState(state);
	}

	
	// post render commit phase
	componentDidMount() {
		console.log('PaymentNoticeScanView.componentDidMount called');

		let mvcmodule = this.getMvcModuleObject();
		
		mvcmodule.registerEventListener('on_refreshPage', this.uuid, this.onRefreshPage.bind(this));

		this._scan();
	}

	async _scan() {
		if (this.invoice) {
			let mvcmodule = this.getMvcModuleObject();
			let mvcmyquote = this.getMvcMyQuoteObject();
	
			let rootsessionuuid = this.props.rootsessionuuid;
			let walletuuid = this.props.currentwalletuuid;

			let currencyuuid = this.invoice.currencyuuid;
			let invoicehash = this.invoice.txhash;

			let paymentnotices = [];
			let message_text = '';

			let canfetch = await mvcmyquote.canFetchTransactions(rootsessionuuid, walletuuid, currencyuuid);

			if (canfetch) {
				paymentnotices = await mvcmyquote.fetchPaymentNotices(rootsessionuuid, walletuuid, currencyuuid, invoicehash)
				.catch(err => {
					console.log('error in PaymentNoticeScanView._scan: ' + err);
				});
	
				message_text = 'found ' + (paymentnotices ? paymentnotices.length : 0) + ' payment notices';

				for (var i = 0; i < (paymentnotices ? paymentnotices.length : 0); i++) {
					paymentnotices[i].uuid = paymentnotices[i].txhash;

					paymentnotices[i].time = (paymentnotices[i].savetime ? paymentnotices[i].savetime/1000 : paymentnotices[i].blocktime);
					paymentnotices[i].formattedtime = mvcmodule.formatDate(paymentnotices[i].time, 'YYYY-mm-dd HH:MM:SS');

					let tokenamount = await mvcmyquote.getCurrencyAmount(rootsessionuuid, currencyuuid, paymentnotices[i].amount);
					let amountstring = await mvcmyquote.formatCurrencyAmount(rootsessionuuid, currencyuuid, tokenamount);
					paymentnotices[i].amountstring = amountstring;
				}
	
				// sort descending payemnt notices
				if (paymentnotices)
				paymentnotices.sort(function(a,b) {return ((b.time !== undefined ? b.time : 0) - (a.time !== undefined ? a.time : 0));});
	
			}
			else {
				/*let blockshift = 1000;
			
 				let new_paymentnotices = await mvcmyquote.scanNextBlockForPaymentNotices(rootsessionuuid, currencyuuid, invoicehash, blockshift)
				.catch(err => {
					console.log('error in PaymentNoticeScanView._scan: ' + err);
				}); */				
			}
			

			this._setState({message_text, paymentnotices})
		}	
	}
	
	async onRefreshPage() {
		console.log('PaymentNoticeScanView.onRefreshPage called');
		//this._scan();
	}
	
	// end of life
	componentWillUnmount() {
		let app = this.app;
		let mvcmodule = app.getMvcModuleObject();
		
		this.closing = true;

		mvcmodule.unregisterEventListener('on_refreshPage', this.uuid);
	}

	
	// user actions
	async onClickItem(item) {
		let txhash = item.txhash;
		let currencyuuid = item.currencyuuid;

		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;
		let walletuuid = this.props.currentwalletuuid;

		let paymentnotice = await mvcmyquote.fetchCurrencyTransaction(rootsessionuuid, walletuuid, currencyuuid, txhash)
		.catch(err => {
			console.log('error in PaymentNoticeListView.onClickItem ' + err);
		});

		if (!paymentnotice) {
			this.app.alert('Could not find payment notice. PaymentNotices may take a few seconds before being fully registered.')
			return;
		}

		let params = {action: 'view', txhash, currencyuuid, dataobject: paymentnotice};

		this.app.gotoRoute('paymentnotice', params);
	}

	renderItem(item){
		let formattedtime = item.formattedtime;
		let amountstring = item.amountstring;
		let uuid= item.txhash;

		return (
			<tr key={uuid} onClick={() => this.onClickItem(item)}>
				<th>{formattedtime}</th>
				<th>{amountstring}</th>
			</tr>
		);

	}

	renderList() {
		let items = this.state.paymentnotices;

		return (
			<Table responsive>
				<thead className="ListHeader">
					<tr>
					<th>Time</th>
					<th>Amount</th>
					</tr>
				</thead>
				<tbody className="ListItem" >
				{items.map((item, index) => {
					return (this.renderItem(item));
				})}
				</tbody>
			</Table>
		);

	}
	
	// rendering
	render() {
		let { message_text, paymentnotices } = this.state;
		
		return (
			<div className="Container">
				{(paymentnotices && paymentnotices.length ? 
				<div>
					<div className="Title">List of Payment Notices</div>
					<div className="TextBox">
					{message_text}
					{this.renderList()}
					</div>
				</div> :
				<></>)}
			</div>
		  );
	}
	
}


// propTypes validation
PaymentNoticeScanView.propTypes = {
	app: PropTypes.object.isRequired,
	rootsessionuuid: PropTypes.string,
};

//redux
const mapStateToProps = (state) => {
	return {
		rootsessionuuid: state.session.sessionuuid,
		pending: state.login.pending,
		success: state.login.success,
		lasterror: state.login.error,
		currentwalletuuid: state.wallets.walletuuid,
	};
}

const mapDispatchToProps = (dispatch) => {
	return {
	};
}


export {PaymentNoticeScanView};
export default connect(mapStateToProps, mapDispatchToProps)(PaymentNoticeScanView);

